import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loadingModal: false,
        loginModal: false,
        loginInfo: {},
        homePageInformation: {},
        publisherInfoDialog: false,
        bookInfoDialog: false,
        yearsInfo: {},
        periodsForSelector01:[{value:0, label:'Χειμερινό', engLabel: 'Ximerino'},{value:1, label:'Εαρινό', engLabel: 'Earino'},],
        periodsForSelector012:[{value:0, label:'Χειμερινό', engLabel: 'Ximerino'},{value:1, label:'Εαρινό', engLabel: 'Earino'},{value:2, label:'Ετήσιο', engLabel: 'Etisio'},],
        navigationItems: [],
        errorPopup: false,
        errorPopupProps: {
            title: 'Σφάλμα!',
            text: 'error',
            color: 'indianRed',
            class: 'white--text indianRed text-center justify-center',
            icon: 'error',
            successStyle:false
        },
       
    },
    getters: {
        loadingModal: state => state.loadingModal,
        loginModal: state => state.loginModal,
        loginInfo: state => state.loginInfo,
        homePageInformation: state => state.homePageInformation,
        publisherInfoDialog: state => state.publisherInfoDialog,
        bookInfoDialog: state => state.bookInfoDialog,
        yearsInfo: state => state.yearsInfo,
        yesNoSelector: state => state.yesNoSelector,
        periodsForSelector01: state => state.periodsForSelector01,
        periodsForSelector012: state => state.periodsForSelector012,
        navigationItems: state => state.navigationItems,
        errorPopup: state => state.errorPopup,
        errorPopupProps: state => state.errorPopupProps,
        bookFileModal: state => state.bookFileModal,
    },
    mutations: {
        setLoadingModal: function (state, data) {
            state.loadingModal = data
        },
        setLoginModal: function (state, data) {
            state.loginModal = data
        },
        setBookHistoryModal: function (state, data) {
            state.bookHistoryModal = data
        },
        setLoginInfo: function (state, data) {
            state.loginInfo = data
        },
        setHomePageInformation: function (state, data) {
            state.homePageInformation = data
        },
        setPublisherInfoDialog: function (state, data) {
            state.publisherInfoDialog = data
        },
        setBookInfoDialog: function (state, data) {
            state.bookInfoDialog = data
        },
        setYearsInfo: function (state, data) {
            state.yearsInfo = data
        },
        setYesNoSelector: function (state, data) {
            state.yesNoSelector = data
        },
        setPeriodsForSelector01: function (state, data) {
            state.periodsForSelector01 = data
        },
        setPeriodsForSelector012: function (state, data) {
            state.periodsForSelector012 = data
        },
        setNavigationItems: function (state, data) {
            state.navigationItems = data
        },
        setErrorPopup: function (state, data) {
            state.errorPopup = data
        },
        setErrorPopupProps: function (state, data) {
            state.errorPopupProps = data
        },
        setBookFileModal: function (state, data) {
            state.bookFileModal = data
        },
    }

});
